import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import Styles from "../style.module.css";

export default function Home() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  });

  if (!isLoaded) return <div>Loading...</div>;

  return <Map />;
}

function Map() {
  const center = { lat: 40.3909, lng: 49.8759 };
  return (
    <div>
      <GoogleMap
        zoom={10}
        center={center}
        mapContainerClassName={Styles.map_container}
      >
        <Marker position={{ lat: 40.3909, lng: 49.8759 }} />
      </GoogleMap>
    </div>
  );
}
